import React, { Component } from 'react';
import styled from 'styled-components';

import Top from './Top';
import Desc from './Desc';
import Bottom from './Bottom';

const Wrapper = styled.div`
  width: 100%;
`;

class About extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  render() {
    const { color, homeData, loading } = this.props;

    return (
      <Wrapper>
        <Top color={color} homeData={homeData} loading={loading} />
        <Desc color={color} />
        <Bottom />
      </Wrapper>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About/index.js